import { ref, toValue } from 'vue';

import useApi from '@/shared/composables/useApi';

export default function useInvoiceLineItemOptions() {
  const { api } = useApi();

  const loadingOptions = ref(false);
  const invoiceLineItemOptions = ref([]);

  const loadOptions = async (params) => {
    if (!params.invoice_id && !params.subsidy_award_period_id) return;

    loadingOptions.value = true;
    const response = await api.shared.invoiceLineItemOption.index(params);

    if (response?.status === 200) {
      invoiceLineItemOptions.value = response.data || [];
    } else {
      invoiceLineItemOptions.value = [];
    }
    loadingOptions.value = false;
  };

  const getSelectedOption = (configurationId) => {
    const id = toValue(configurationId);
    const options = toValue(invoiceLineItemOptions);
    if (!id || !options.length) return null;

    return options.find((option) => option.invoice_line_item_configuration_id === id);
  };

  const getDisplayRateDescription = (configurationId) => {
    const option = getSelectedOption(configurationId);
    return option?.rate_description || null;
  };

  const getConfigurationDescription = (configurationId) => {
    const option = getSelectedOption(configurationId);
    return option?.description || null;
  };

  const clearOptions = () => {
    invoiceLineItemOptions.value = [];
    loadingOptions.value = false;
  };

  return {
    loadingOptions,
    invoiceLineItemOptions,
    loadOptions,
    getSelectedOption,
    getDisplayRateDescription,
    getConfigurationDescription,
    clearOptions,
  };
}
